import { useState } from "react";
import LinkButton from "../../../components/UI/button/link-btn";
import { isJson } from "../../../shared/utility";
import JsonPrettyViewer from "../component/JsonPrettyViewer.jsx";
import XmlPrettyViewer from "../component/XmlPrettyViewer.jsx";

export const RequestResponsePayload = (props) => {
  const { integData } = props;

  const [allColapsed, setAllColapsed] = useState(true);

  const getPayloadInfo = (integDataNew) => {
    const isJsonReqPayload = isJson(integDataNew.RequestPayload);
    const isJsonResPayload = isJson(integDataNew.ResponsePayload);
    return {
      isJsonReqPayload: isJsonReqPayload || false,
      isJsonResPayload: isJsonResPayload || false,
      requestPayloadData: integDataNew?.RequestPayload,
      responsePayloadData: integDataNew?.ResponsePayload,
      responseLog: integDataNew.ResponseLog || null
    };
  };
  const payloadData = getPayloadInfo(integData);


  const renderEmptyPayloadSection = () => {
    return <span class='red-color ml-3'> No Response Received" +
      Check Error / Response Log for details
    </span>;
  }

  // useEffect(() => {
  // }, []);

  return (
    <section
      className="grid-table expand-bg-color"
      id="requestResponsePayloadTable"
    >
      <div className="d-flex font-weight-bold pt-1">
        <div
          className="text-right pt-2 font-weight-bold"
          id="expand-collapse-id"
        >
          <div
            className="pl-4 pr-4"
            onClick={() => setAllColapsed(false)}
          >
            <LinkButton
              btnLabel="Expand All"
              containerClass="pseudo-link fs-2 font-weight-bold d-flex align-items-center"
              stackClass="fa-stack fs-08 vertical-align-top"
              faIconList={[
                "fa fa-square fa-stack-2x iconBeforeLink",
                "fa fa-sort-down fa-stack-1x whiteColor pr-1 fs-6 topr-0-3",
              ]}
            />
          </div>
          <div className="pl-4" onClick={() => setAllColapsed(true)}>
            <LinkButton
              btnLabel="Collapse All"
              containerClass="pseudo-link pr-2 fs-2 font-weight-bold d-flex align-items-center"
              stackClass="fa-stack fs-08 vertical-align-top"
              faIconList={[
                "fa fa-square fa-stack-2x iconBeforeLink",
                "fa fa-sort-up fa-stack-1x whiteColor pr-1 fs-6 top-0-3",
              ]}
            />
          </div>
        </div>
      </div>
      <div
        className="pl-3 mtr-2 tableScroll mr-2"
        style={{
          borderBottom: "none",
          fontSize: "11px",
          maxHeight: "40rem"
        }}
      >
        <div className="pb-3">
          {integData.RequestPayload ? !payloadData.isJsonReqPayload ?
            <XmlPrettyViewer title="Request Payload" dataString={integData.RequestPayload} collapsed={allColapsed} />
            : <JsonPrettyViewer title="Request Payload" dataString={integData.RequestPayload} collapsed={allColapsed} />
            : renderEmptyPayloadSection()}
        </div>
        <div className="pb-3">
          {integData.ResponsePayload ? !payloadData.isJsonResPayload
            ? <XmlPrettyViewer title="Response Payload" dataString={integData.ResponsePayload} collapsed={allColapsed} />
            : <JsonPrettyViewer title="Response Payload" dataString={integData.ResponsePayload} collapsed={allColapsed} /> :
            renderEmptyPayloadSection()}
        </div>
      </div>
    </section>
  );
};

export default RequestResponsePayload;